// extracted by mini-css-extract-plugin
export default {"mainFormVisibility":"mainFormVisibility---dtymL","recordTypeField":"recordTypeField---vOMyP","radioLabels":"radioLabels---zGeTY","tooltipContent":"tooltipContent---Zn5Ju"};